import React, { useState } from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

const AIGenerateButton = ({ 
  productId, 
  platforms = [], 
  onGenerate, 
  disabled = false,
  size = 'default',
  variant = 'default'
}) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleClick = async () => {
    if (!productId || platforms.length === 0) {
      return;
    }

    setIsGenerating(true);
    try {
      await onGenerate();
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <Button
      data-testid="ai-generate-button"
      onClick={handleClick}
      disabled={disabled || isGenerating || !productId || platforms.length === 0}
      size={size}
      variant={variant}
      className="gap-2"
    >
      {isGenerating ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          Génération en cours...
        </>
      ) : (
        <>
          <Sparkles className="h-4 w-4" />
          Générer avec IA
        </>
      )}
    </Button>
  );
};

export default AIGenerateButton;
